import { LanguageService } from 'services/language-service';
import { ManagedUser } from 'shared/interfaces/ManagedUser';
import { Organisation, OrganisationStatus } from 'shared/interfaces/Organisation';
import { OrganisationUsage } from 'shared/interfaces/Usage';
import { UpdateUserRoleDto, User, UserInviteDto } from 'shared/interfaces/User';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const organisationBaseEndpoint = '/organisation';

export const OrganisationService = {
  inviteUser: async (userInviteDto: UserInviteDto): Promise<User> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${organisationBaseEndpoint}/invite-user`,
      data: {
        ...userInviteDto,
        email: userInviteDto.email.toLowerCase(),
        locale: LanguageService.getCurrentLanguage()
      }
    });

    return response.data;
  },

  updateUserRole: async (user: User): Promise<User> => {
    const updateUserDto: UpdateUserRoleDto = {
      userId: user._id,
      role: user.role
    };

    const response = await axiosBaseInstance({
      method: 'put',
      url: `${organisationBaseEndpoint}/update-user-role`,
      data: updateUserDto
    });

    return response.data;
  },

  deleteUser: async (userId: string): Promise<string> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${organisationBaseEndpoint}/delete-user`,
      data: {
        userId: userId
      }
    });

    return response.data._id;
  },

  getUser: async (userId: string): Promise<ManagedUser> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${organisationBaseEndpoint}/user/${userId}`
    });

    return response.data;
  },

  getOrganisationStatus: async (): Promise<OrganisationStatus> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${organisationBaseEndpoint}/status`
    });

    return response.data;
  },

  getAllUsers: async (): Promise<User[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${organisationBaseEndpoint}/users`
    });

    return response.data;
  },

  getOrganisation: async (): Promise<Organisation> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${organisationBaseEndpoint}`
    });

    return response.data;
  },

  deleteOrganisation: async (): Promise<void> => {
    await axiosBaseInstance({
      method: 'delete',
      url: `${organisationBaseEndpoint}`
    });
  },

  getOrganisationUsage: async (): Promise<OrganisationUsage> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${organisationBaseEndpoint}/usage`
    });

    return response.data;
  }
};
